
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon--social icon--facebook",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"class":"icon icon--social icon--facebook","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M22.1 17.2l.7-5.4h-5.4V8.3c0-1.6.4-2.7 2.7-2.7H23V.7c-.5-.1-2.2-.2-4.2-.2-4.2 0-7 2.5-7 7.2v4.1H7v5.4h4.8v12.2h5.7V17.2h4.6z"}})])
          )
        }
      }
    